import IconTypeFilter from 'filters/TypeFilter/IconTypeFilter';
import { ProductType } from '@inter-ikea-storageone/range';
import { FilterType } from 'rangeConfig/@types';
import RegularBench from 'rangeConfig/Icons/RegularBench.svg?react';
import TVBench from 'rangeConfig/Icons/TVBench.svg?react';
import DoorTypeIcon from 'rangeConfig/Icons/DoorType.svg?react';
import DrawerTypeIcon from 'rangeConfig/Icons/DrawerType.svg?react';

export const framesTypeFilter = {
  component: IconTypeFilter,
  title: 'storageone.typeFilterLabel',
  id: 'type',
  type: FilterType.FILTER,
  options: [
    {
      id: 'frame',
      name: 'storageone.filterOptionHandles',
      icon: RegularBench,
      types: [ProductType.BESTA_FRAME_600_ASM, ProductType.BESTA_FRAME_1200_ASM]
    },
    {
      id: 'tvBench',
      name: 'storageone.filterOptionHandles',
      icon: TVBench,
      types: [ProductType.BESTA_TV_BENCH_1200_ASM, ProductType.BESTA_TV_BENCH_1800_ASM]
    }
  ]
};

export const frontTypeFilter = {
  component: IconTypeFilter,
  title: 'storageone.typeFilterLabel',
  id: 'type',
  type: FilterType.FILTER,
  options: [
    {
      id: 'doors',
      name: 'storageone.filterOptionDoors',
      icon: DoorTypeIcon,
      types: [
        ProductType.BESTA_DOOR_38_ASM,
        ProductType.BESTA_DOOR_64_ASM,
        ProductType.BESTA_DOOR_192_ASM
      ]
    },
    {
      id: 'drawers',
      name: 'storageone.filterOptionDrawers',
      icon: DrawerTypeIcon,
      types: [ProductType.BESTA_DRAWER_26_ASM, ProductType.BESTA_DRAWER_38_ASM]
    }
  ]
};
